(function () {
'use strict';
var root = document.getElementById('athar-mockup');
var dataEl = document.getElementById('AtharMockupData');
if (!root || !dataEl) return;
var DATA = JSON.parse(dataEl.textContent);
var PRODUCTS = DATA.products.filter(function (p) { return p.variants.length; });
if (!PRODUCTS.length) return;
var L = window.AtharMockupLib, FX = window.AtharMockupFx;
var apply = L.apply, invert = L.invert, cssMatrix = L.cssMatrix, dist = L.dist;
var parseSize = FX.parseSize, cmLabel = FX.cmLabel, uniq = FX.uniq, frameKey = FX.frameKey;
var FRAME_MM = 20, GAP_MM = 250;
var ROOMS = (DATA.rooms || []).slice();
ROOMS.push({ name: 'Sample room', drawn: true, ppc: 4, hang: [800, 330] });
function $(s) { return root.querySelector(s); }
function $all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
function num(x) { return parseFloat(String(x || '').replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; }).replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x6F0; }).replace(/[٫,،]/g, '.').replace(/[^0-9.]/g, '')); }
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
var S = {
mode: 'place', room: 0, evening: false, own: false,
line: [[0.3, 0.62], [0.7, 0.62]], cm: null,
center: null, recenter: true, off: [0, 0], H: null, Hinv: null, dw: 0, dh: 0,
pi: Math.max(0, PRODUCTS.findIndex(function (p) { return p.handle === DATA.current; })),
size: null, frame: null, obj: null, P: FX.look(null)
};
var stage = $('.am-stage'), canvasEl = $('.am-canvas'), photo = $('.am-photo'), plane = $('.am-plane');
var frameEl = $('.am-frame'), artImg = $('.am-art'), tintEl = $('.am-tint'), lightEl = $('.am-light');
var fileInput = $('.am-file'), sheet = $('.am-rooms-sheet'), welcome = $('.am-welcome'), toastEl = $('.am-toast');
var lineEl = $('.am-line'), handles = $all('.am-handle'), loupe = $('.am-loupe'), cmInput = $('.am-cm'), doneBtn = $('[data-action="measured"]');
document.documentElement.classList.add('am-lock');
var toastTimer;
function toast(en, ar, ms) {
toastEl.innerHTML = '';
[en, ar].forEach(function (t, i) { if (!t) return; var sp = document.createElement('span'); sp.textContent = t; if (i) { sp.dir = 'rtl'; sp.lang = 'ar'; } toastEl.appendChild(sp); });
toastEl.hidden = false;
clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.hidden = true; }, ms || 3500);
}
function loadPhoto(url, after) {
photo.onload = function () { FX.sample(photo); setTimeout(function () { S.recenter = true; render(); if (after) after(); }, 0); };
photo.src = url;
}
function roomSrc(r, eve) {
if (!r.drawn) return eve && r.evening ? r.evening : r.day;
var k = eve ? '_e' : '_d';
if (!r[k]) { var c = document.createElement('canvas'); L.drawSampleRoom(c, eve); r[k] = c.toDataURL('image/jpeg', 0.9); }
return r[k];
}
function hasEvening() { return !S.own && (ROOMS[S.room].drawn || !!ROOMS[S.room].evening); }
function setMode(m) {
S.mode = m; root.setAttribute('data-mode', m);
root.setAttribute('data-own', S.own ? 'yes' : 'no');
root.setAttribute('data-evening', hasEvening() ? (S.evening ? 'on' : 'off') : 'none');
S.recenter = true; render();
}
function openRoom(i, after) {
S.own = false; S.room = i; S.center = null;
if (!hasEvening()) S.evening = false;
setMode('place'); loadPhoto(roomSrc(ROOMS[i], S.evening), after);
}
function openOwn(file) {
S.own = true; S.center = null; S.evening = false; S.cm = null; cmInput.value = ''; checkCm();
S.line = [[0.3, 0.62], [0.7, 0.62]];
loadPhoto(URL.createObjectURL(file), function () { setMode('measure'); tourOnce('measure'); });
}
function checkCm() {
var v = num(cmInput.value);
doneBtn.disabled = !(v >= 5 && v <= 3000);
$('.am-tag').classList.toggle('is-empty', !(v > 0));
return v;
}
cmInput.addEventListener('input', function () { checkCm(); render(); });
cmInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); cmInput.blur(); doneBtn.click(); } });
function buildRooms() {
var wrap = $('.am-room-list');
ROOMS.forEach(function (r, i) {
var b = document.createElement('button');
b.type = 'button'; b.className = 'am-room';
var im = document.createElement('img'); im.alt = ''; im.src = r.drawn ? roomSrc(r, false) : (r.thumb || r.day);
var t = document.createElement('span'); t.textContent = r.name;
b.appendChild(im); b.appendChild(t);
b.addEventListener('click', function () { sheet.hidden = true; openRoom(i); });
wrap.appendChild(b);
});
}
fileInput.addEventListener('change', function () {
var f = fileInput.files && fileInput.files[0];
if (f) { welcome.hidden = true; sheet.hidden = true; openOwn(f); }
});
root.addEventListener('click', function (e) {
var t = e.target.closest('[data-action]');
if (!t || !root.contains(t)) return;
var a = t.getAttribute('data-action');
if (a === 'rooms') sheet.hidden = false;
if (a === 'close-sheet' && e.target === t) sheet.hidden = true;
if (a === 'own') { sheet.hidden = true; welcome.hidden = false; }
if (a === 'camera' || a === 'upload') { if (a === 'camera') fileInput.setAttribute('capture', 'environment'); else fileInput.removeAttribute('capture'); fileInput.value = ''; fileInput.click(); }
if (a === 'sample') { welcome.hidden = true; openRoom(0, function () { tourOnce('place'); }); }
if (a === 'measure') setMode('measure');
if (a === 'measured') { var v = checkCm(); if (!doneBtn.disabled) { S.cm = v; S.center = null; setMode('place'); toast('Shown at its true size.', 'تظهر بحجمها الحقيقي.', 3000); tourOnce('place'); } }
if (a === 'evening') { S.evening = !S.evening; setMode('place'); loadPhoto(roomSrc(ROOMS[S.room], S.evening)); }
if (a === 'cart') L.addToCart(t, variant().id);
if (a === 'share') share();
if (a === 'help') runTour(S.mode === 'measure' ? 'measure' : 'place');
});
function product() { return PRODUCTS[S.pi]; }
function sizesOf(p) {
return uniq(p.variants.map(function (v) { return v.size; })).filter(parseSize).sort(function (a, b) { return parseSize(a)[1] - parseSize(b)[1]; });
}
function framesOf(p) { return uniq(p.variants.map(function (v) { return v.frame; })); }
function variant() {
var p = product();
return p.variants.find(function (v) { return v.size === S.size && v.frame === S.frame; }) || p.variants.find(function (v) { return v.size === S.size; }) || p.variants[0];
}
function dims() {
var d = parseSize(S.size) || [400, 600], ratio = S.obj ? S.obj.ratio : 2 / 3, lo = d[1] + 2 * FRAME_MM;
return ratio > 1 ? { fw: lo, fh: lo / ratio } : { fw: lo * ratio, fh: lo };
}
var token = 0;
function loadObj() {
var v = variant(), t = ++token, im = new Image();
root.classList.add('is-loading');
im.onload = function () { if (t !== token) return; S.obj = FX.trim(im); artImg.src = S.obj.url; root.classList.remove('is-loading'); render(); };
im.src = v.img || product().art;
}
function selectProduct(i) {
S.pi = i;
var p = product(), sizes = sizesOf(p), frames = framesOf(p);
if (sizes.indexOf(S.size) === -1) S.size = sizes[Math.min(1, sizes.length - 1)] || null;
if (frames.indexOf(S.frame) === -1) S.frame = frames[0];
$all('.am-thumb').forEach(function (t, j) { t.setAttribute('aria-pressed', String(j === i)); });
buildOptions(); loadObj();
}
function buildPicker() {
var wrap = $('.am-picker');
PRODUCTS.forEach(function (p, i) {
var b = document.createElement('button');
b.type = 'button'; b.className = 'am-thumb';
b.setAttribute('aria-label', p.title);
var im = document.createElement('img'); im.src = p.thumb; im.alt = '';
b.appendChild(im);
b.addEventListener('click', function () { selectProduct(i); });
wrap.appendChild(b);
});
}
function buildOptions() {
var p = product(), sw = $('.am-sizes'), fw = $('.am-frames');
sw.innerHTML = ''; fw.innerHTML = '';
sizesOf(p).forEach(function (s) {
var d = parseSize(s), b = document.createElement('button');
b.type = 'button'; b.className = 'am-size'; b.textContent = cmLabel(d[0]) + '×' + cmLabel(d[1]);
b.setAttribute('aria-pressed', String(s === S.size));
b.setAttribute('aria-label', cmLabel(d[0]) + ' by ' + cmLabel(d[1]) + ' cm');
b.addEventListener('click', function () { S.size = s; buildOptions(); loadObj(); });
sw.appendChild(b);
});
framesOf(p).forEach(function (f) {
var b = document.createElement('button');
b.type = 'button'; b.className = 'am-swatch';
b.style.setProperty('--sw', FX.SWATCH[frameKey(f)]);
b.setAttribute('aria-label', f); b.title = f;
b.setAttribute('aria-pressed', String(f === S.frame));
b.addEventListener('click', function () { S.frame = f; buildOptions(); loadObj(); });
fw.appendChild(b);
});
}
function natLine() { var nw = photo.naturalWidth, nh = photo.naturalHeight; return S.line.map(function (p) { return [p[0] * nw, p[1] * nh]; }); }
function ppc() {
if (!S.own) return ROOMS[S.room].ppc;
var l = natLine(); return dist(l[0], l[1]) / (S.cm || 100);
}
function render() {
var nw = photo.naturalWidth, nh = photo.naturalHeight;
if (!nw) return;
var vw = stage.clientWidth, vh = stage.clientHeight, m = S.mode === 'measure';
var sc = Math.max(vw / nw, vh / nh);
S.dw = nw * sc; S.dh = nh * sc;
canvasEl.style.width = S.dw + 'px'; canvasEl.style.height = S.dh + 'px';
var s = ppc() / 10 * sc;
S.H = [s, 0, 0, 0, s, 0, 0, 0, 1]; S.Hinv = invert(S.H);
var D = dims();
if (!S.center) {
if (S.own) {
var l = natLine(), mx = (l[0][0] + l[1][0]) / 2 * 10 / ppc(), my = (l[0][1] + l[1][1]) / 2 * 10 / ppc(), cy = my - GAP_MM - D.fh / 2;
if (cy - D.fh / 2 < 0) cy = nh * 10 / ppc() * 0.4;
S.center = [mx, cy];
} else { var r = ROOMS[S.room]; S.center = [r.hang[0] * 10 / r.ppc, r.hang[1] * 10 / r.ppc]; }
}
if (S.recenter) {
var c = m ? [(S.line[0][0] + S.line[1][0]) / 2 * S.dw, (S.line[0][1] + S.line[1][1]) / 2 * S.dh] : apply(S.H, S.center[0], S.center[1]);
S.off = [vw / 2 - c[0], (m ? 0.45 : 0.36) * vh - c[1]];
}
S.off = [clamp(S.off[0], vw - S.dw, 0), clamp(S.off[1], vh - S.dh, 0)];
S.recenter = false;
canvasEl.style.transform = 'translate(' + S.off[0] + 'px,' + S.off[1] + 'px)';
if (m) {
var a0 = [S.line[0][0] * S.dw, S.line[0][1] * S.dh], a1 = [S.line[1][0] * S.dw, S.line[1][1] * S.dh];
lineEl.setAttribute('x1', a0[0]); lineEl.setAttribute('y1', a0[1]); lineEl.setAttribute('x2', a1[0]); lineEl.setAttribute('y2', a1[1]);
handles.forEach(function (h, i) { var p = i ? a1 : a0; h.style.left = p[0] + 'px'; h.style.top = p[1] + 'px'; });
var tag = $('.am-tag');
tag.style.left = (a0[0] + a1[0]) / 2 + 'px'; tag.style.top = (a0[1] + a1[1]) / 2 + 'px';
return;
}
var x0 = S.center[0] - D.fw / 2, y0 = S.center[1] - D.fh / 2;
frameEl.style.left = x0 + 'px'; frameEl.style.top = y0 + 'px';
frameEl.style.width = D.fw + 'px'; frameEl.style.height = D.fh + 'px';
frameEl.style.visibility = S.obj ? '' : 'hidden';
plane.style.transform = cssMatrix(S.H);
var b0 = apply(S.H, x0, y0), b1 = apply(S.H, x0 + D.fw, y0 + D.fh);
S.P = FX.look(FX.measure({ x0: b0[0], y0: b0[1], x1: b1[0], y1: b1[1] }, S.dw));
FX.styleDom(frameEl, artImg, tintEl, lightEl, S.P);
var vr = variant(), d = parseSize(S.size) || [0, 0];
var tl = $('.am-title'); tl.textContent = product().title; tl.href = product().url; $('.am-view').href = product().url;
$('.am-price').innerHTML = vr.price;
$('.am-meta').textContent = cmLabel(d[0]) + ' × ' + cmLabel(d[1]) + ' cm · ' + String(S.frame || '').toLowerCase();
var atc = $('[data-action="cart"]');
atc.disabled = !vr.available; atc.textContent = vr.available ? 'Add to cart' : 'Sold out';
}
window.addEventListener('resize', function () { S.recenter = true; setTimeout(render, 0); });
function pt(e) { var r = photo.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
function drag(el, move, end) {
function up() { el.removeEventListener('pointermove', move); el.removeEventListener('pointerup', up); el.removeEventListener('pointercancel', up); if (end) end(); }
el.addEventListener('pointermove', move); el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
}
handles.forEach(function (h, i) {
h.addEventListener('pointerdown', function (e) {
e.preventDefault(); h.setPointerCapture(e.pointerId); h.classList.add('is-dragging');
function move(ev) {
var p = pt(ev);
S.line[i] = [clamp(p[0] / S.dw, 0, 1), clamp(p[1] / S.dh, 0, 1)];
var x = S.line[i][0] * S.dw, y = S.line[i][1] * S.dh, Z = 3, R = 60;
loupe.hidden = false; loupe.style.left = x + 'px'; loupe.style.top = (y - 110) + 'px';
loupe.style.backgroundImage = 'url("' + photo.src + '")';
loupe.style.backgroundSize = (S.dw * Z) + 'px ' + (S.dh * Z) + 'px';
loupe.style.backgroundPosition = (R - x * Z) + 'px ' + (R - y * Z) + 'px';
render();
}
drag(h, move, function () { h.classList.remove('is-dragging'); loupe.hidden = true; });
move(e);
});
});
frameEl.addEventListener('pointerdown', function (e) {
if (!S.Hinv) return;
e.preventDefault(); frameEl.setPointerCapture(e.pointerId); frameEl.classList.add('is-dragging');
var p0 = pt(e), q0 = apply(S.Hinv, p0[0], p0[1]), off = [S.center[0] - q0[0], S.center[1] - q0[1]];
drag(frameEl, function (ev) { var p = pt(ev), q = apply(S.Hinv, p[0], p[1]); S.center = [q[0] + off[0], q[1] + off[1]]; render(); }, function () { frameEl.classList.remove('is-dragging'); });
});
stage.addEventListener('pointerdown', function (e) {
if (e.target.closest('.am-handle, .am-frame, .am-tag')) return;
var sx = e.clientX, sy = e.clientY, o0 = S.off.slice();
stage.setPointerCapture(e.pointerId); canvasEl.style.transition = 'none';
drag(stage, function (ev) { S.off = [o0[0] + ev.clientX - sx, o0[1] + ev.clientY - sy]; render(); }, function () { canvasEl.style.transition = ''; });
});
function share() {
if (!S.obj) return;
toast('Preparing your image…', 'جارٍ تجهيز الصورة…', 2500);
var D = dims(), proxy = { textContent: '', disabled: false };
L.save(proxy, { photo: photo, dw: S.dw, H: S.H, center: S.center, fw: D.fw, fh: D.fh, obj: S.obj.canvas || artImg, P: S.P, paint: FX.paint, text: product().title + ' · ' + location.origin + product().url });
}
var TOURS = {
measure: [
{ el: function () { return lineEl; }, pad: 34, art: FX.DOOR, en: 'Put the two dots on the ends of something you measured. Example: a door, top to bottom, 210 cm.', ar: 'ضع النقطتين على طرفَي شيء قِسته. مثلاً باب، من أعلاه إلى أسفله: ٢١٠ سم.' },
{ el: function () { return $('.am-tag'); }, pad: 10, en: 'Type the length here, on the ?. Example: 210', ar: 'اكتب الطول هنا مكان علامة ؟ مثلاً: ٢١٠' },
{ el: function () { return doneBtn; }, en: 'Then tap Done.', ar: 'ثم اضغط تم.' }
],
place: [
{ el: function () { return frameEl; }, en: 'Drag the piece to move it.', ar: 'اسحب اللوحة لتحريكها.' },
{ el: function () { return $('.am-shop'); }, en: 'Choose the piece, size and frame.', ar: 'اختر اللوحة والمقاس والإطار.' }
]
};
function runTour(k) { FX.tour(root, TOURS[k], function () { try { localStorage.setItem('atharn-tour-' + k, '1'); } catch (e) {} }); }
function tourOnce(k) { var seen = false; try { seen = localStorage.getItem('atharn-tour-' + k) === '1'; } catch (e) {} if (!seen) setTimeout(function () { runTour(k); }, 600); }
buildRooms(); buildPicker(); selectProduct(S.pi); openRoom(0);
})();